import url from 'scoreboard/components/url'

const params = url.getQueryParams(window.requestedUri)

/**
 * Global attributes having to do with export state
 */
const exportState = {}
Object.defineProperties(exportState, {
	/**
	 * State that was persisted during an export that should be re-applied
	 * to a view before an export is captured.
	 *   - Unsaved changes to reports
	 *   - Unsaved dataset filters
	 *   - Unsaved changes to dashboard widgets
	 */
	state: {
		writable: true
	},

	/**
	 * The state is stored in the session and made available to every view
	 * loaded during that session.  For briefings only one slide should apply
	 * the state, so if this parameter is false the state should not be applied.
	 */
	shouldApply: {
		value: params.applyState
	},

	/**
	 * Centralized place to read the query string `state` parameter
	 */
	fromQueryString: {
		value: params.state
	}
})

export default exportState
exportState.__filename__ = 'components/export/export-state.js'
